import { ABACUS_CONTEXT } from '@/constants/context';
import { VIDEO_URLS } from '@/constants/videos';
import React from 'react';

const Abacus = () => {
  return (
    <div
      id='content-Abacus'
      className='w-full h-full flex flex-col box-border gap-4 xl:gap-6'
    >
      <div className='flex flex-col gap-4 md:gap-6 xl:w-[530px] xl:h-[400px] md:h-[350px] h-[642px]'>
        <div className='w-full flex flex-col justify-start px-4 md:px-0'>
          <h1 className='leading-7 md:leading-8 text-4xl md:text-4xl font-bold text-white text-left'>
            <strong>
              42-<span className='text-[#fccb15]'>A</span>bacus
            </strong>
          </h1>
        </div>
        <div className='border-l-4 border-[#FCCB16] md:pl-3 ml-4 md:ml-0' >
          <div className='text-base md:text-xl font-semibold text-white px-4 md:px-0 xl:hidden'>
            {ABACUS_CONTEXT.SUBTITLE}
          </div>
          <div className='hidden xl:block text-lg font-medium text-white'>
            {ABACUS_CONTEXT.SUBTITLE.split('analytics').map((part, index) => (
              <p key={index}>
                {index === 0 ? part + 'analytic' : part.trim()}
              </p>
            ))}
          </div>
        </div>
        <div className='w-full flex justify-start items-start px-4 md:px-0'>
          <section className='w-full flex justify-start'>
            <div className='text-sm md:text-lg font-medium text-white md:text-justify xl:hidden'>
              {ABACUS_CONTEXT.DESCRIPTION}
            </div>
            <div className='hidden xl:block text-lg font-medium text-white'>
              {ABACUS_CONTEXT.DESCRIPTION.split('of satellite.').map((part, index) => (
                <p key={index}>
                  {index === 0 ? part + 'of satellite.' : part.trim()}
                </p>
              ))}
            </div>
          </section>
        </div>
        <div className='md:hidden relative w-[calc(100%+2rem)] h-[319px] overflow-hidden rounded-lg -mx-4'>
          <video
            className='absolute inset-0 w-full h-full object-cover pointer-events-none'
            playsInline
            muted
            autoPlay
            loop
            controls={false}
            disablePictureInPicture
            onContextMenu={e => e.preventDefault()}
          >
            <source src={VIDEO_URLS.ABACUS} />
          </video>
        </div>
      </div>

      {/* Mobile & Tablet Video */}
      <div className='xl:hidden hidden md:block relative w-full h-[350px] overflow-hidden rounded-lg'>
        <video
          className='w-full h-full object-cover pointer-events-none'
          controls={false}
          disablePictureInPicture
          playsInline
          onContextMenu={e => e.preventDefault()}
          muted
          autoPlay
          loop
        >
          <source src={VIDEO_URLS.ABACUS} />
        </video>
      </div>

      {/* Desktop Video */}
      <video
        className='hidden xl:block absolute bottom-[20%] left-[45%] w-[698px] h-[351px] object-cover pointer-events-none z-[-100]'
        muted
        autoPlay
        loop
        controls={false}
        disablePictureInPicture
        playsInline
        onContextMenu={e => e.preventDefault()}
      >
        <source src={VIDEO_URLS.ABACUS} />
      </video>
    </div>
  );
};

export default React.memo(Abacus);
